import { change, formValueSelector } from 'redux-form/immutable'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { MICROACTIONS_PATH } from 'app/constants/navLinks'
import { fromJS } from 'immutable'
import uniqBy from 'lodash/uniqBy'

import { getOrganizationSettingsByDomainCountriesCodes } from 'store/entities/organizationSettings/selectors'
import { getGlobalCountriesCodes } from 'store/entities/localSettings/selectors'
import { getCountriesCodesBySelectedOrganizationId } from 'store/entities/organizations/selectors.ts'
import CountryCodeSelect from './CountryCodeSelect'
import { mapCountriesCodeForSelect, mapObjCountriesCodes } from 'helpers/parsePhone'

const getFieldName = prefixForField => (prefixForField ? `${prefixForField}phone` : 'phone')

const mapStateToProps = (state, ownProps) => ({
  selectedValue: formValueSelector(ownProps.meta.form)(state, ownProps.input.name),
  selectedValuePhone: formValueSelector(ownProps.meta.form)(state, getFieldName(ownProps.prefixForField)),
  phoneFieldName: getFieldName(ownProps.prefixForField),
  countriesCodes: getOrganizationSettingsByDomainCountriesCodes(state),
  globalCountriesCodes: getGlobalCountriesCodes(state),
  objectCountriesCodesBySelectedOrganization: getCountriesCodesBySelectedOrganizationId(state),
})

const mapDispatchToProps = {
  handleOnChange: (formName, field, value) => change(formName, field, value),
}

const mergeProps = (
  { selectedValue, objectCountriesCodesBySelectedOrganization, countriesCodes, globalCountriesCodes, ...stateProps },
  dispatchProps,
  { location, ...ownProps }
) => {
  let options
  if (location.pathname === `${MICROACTIONS_PATH}/users` || location.pathname === `${MICROACTIONS_PATH}/users/invite`) {
    options = fromJS(mapObjCountriesCodes(objectCountriesCodesBySelectedOrganization.toJS()))
  } else {
    options = countriesCodes
  }

  // optionsForDisabledCodes is code which was enabled for Org but now is disabled. But user has number with old code
  const optionsForDisabledCodes = globalCountriesCodes.filter(
    countryCode => countryCode.get('country') === selectedValue
  )

  const optionsForSelect = mapCountriesCodeForSelect(optionsForDisabledCodes.concat(options)).toJS()
  options = uniqBy(optionsForSelect, 'value')
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    options,
    selectedValue,
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(CountryCodeSelect))
